<template>
  <div>
    <el-container>
      <el-header class="el-header-top" height="60px">
        <Header :selectTopMenu="selectTopMenu" />
      </el-header>
      <el-container>
        <el-aside :width="asideWidth">
          <Menu ref="menu" :selectLeftMenu="selectLeftMenu" @collapseHandle="collapseHandle"/>
        </el-aside>
        <el-container>
          <el-header class="el-header-nav">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item><i class="el-icon-menu breadcrumb-icon"></i>{{ menuName }}</el-breadcrumb-item>
            </el-breadcrumb>
          </el-header>
          <el-main>
            <router-view />
          </el-main>
          <el-footer>{{ copyright }}</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "@/views/main/Header";
import Menu from "@/views/main/Menu";

export default {
  name: "Main",
  components: { Header, Menu },
  data() {
    return {
      asideWidth: "250px",
      //当前选中菜单名称
      menuName: "",
      //版权信息
      copyright: 'Copyright © 2023 - XXX有限公司'
    }
  },
  methods: {
    //顶部菜单选中触发
    selectTopMenu: function (menus) {
      this.$refs.menu.selectTopMenu(menus);
    },
    //点击左侧菜单
    selectLeftMenu: function (menu) {
      //设置标题栏显示名称
      this.menuName = menu.name;
      //页面跳转
      if (menu.type === 2) {
        //链接
        this.$router.push({
          path: "/main/iframe",
          query: {
            url: menu.url,
          },
        });
      } else if(menu.type === 3){
        //打开新的窗口
        window.open(menu.url)
      } else {
        //普通菜单跳转
        this.$router.push(menu.url);
      }
    },
    //菜单切换
    collapseHandle(status) {
      this.asideWidth = status ? "65px" : "250px"
    },
    //版权信息获取
    getCopyright: function(){
      this.$axios.get('/tbParams/getParamValue', { params: { code: 'SYS_COPYRIGHT' } }).then(res => this.copyright = res || 'Copyright © 2023 - XXX有限公司')
    }
  },
  mounted() {
    //版权信息获取
    this.getCopyright()
  }
};
</script>

<style scoped>
div, .el-container {
  height: 100%;
}

.el-header-top {
  background-color: #6696b9;
  height: 60px !important;
  line-height: 60px;
  color: #f2f2ff;
  font-size: 21px;
}

.el-header-nav {
  height: 46px !important;
  padding: 0;
}

.el-aside {
  background-color: rgb(44, 95, 154);
}

.el-footer {
  background-color: #ececec;
  height: 40px !important;
  line-height: 40px;
  text-align: right;
  padding-right: 20px;
  font-size: 12px;
}

.el-main {
  padding: 0;
}

.el-breadcrumb {
  background-color: #ececec;
  line-height: 46px;
  border-left: 5px solid #409eff;
}

.breadcrumb-icon {
  color: #666;
  margin-left: 5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/main/Main.vue